export default "__VITE_PUBLIC_ASSET__3203c3ee__"